/**
 * Paginate through a PostgREST query to bypass the default 1000-row cap.
 *
 * Pass a thunk that returns a fresh query builder (we apply `.range()` to a
 * new builder per page). Stops when a page returns fewer rows than pageSize.
 */
export async function fetchAllRows<T>(
  buildQuery: () => any,
  opts: { pageSize?: number } = {},
): Promise<T[]> {
  const pageSize = opts.pageSize ?? 1000;
  const all: T[] = [];
  let offset = 0;
  // Safety cap to avoid runaway loops on pathological data.
  for (let i = 0; i < 1000; i++) {
    const { data, error } = await buildQuery().range(offset, offset + pageSize - 1);
    if (error) throw error;
    const rows = (data ?? []) as T[];
    all.push(...rows);
    if (rows.length < pageSize) break;
    offset += pageSize;
  }
  return all;
}